import { createSlice } from '@reduxjs/toolkit';

const deviceSlice = createSlice({
  name: 'device',
  initialState: {
    devices: [],
  },
  reducers: {
    setDevices(state, action) {
      state.devices = action.payload || [];
    },
    upsertDevice(state, action) {
      const d = action.payload;
      if (!d?.id) return;
      const idx = state.devices.findIndex(x => x.id === d.id);
      if (idx >= 0) state.devices[idx] = { ...state.devices[idx], ...d };
      else state.devices.unshift(d);
    },
  },
});

export const { setDevices, upsertDevice } = deviceSlice.actions;
export default deviceSlice.reducer;
